<div class="product-step">
  <h3 class="title">{{ "venta-rapida.product-step.title" | translate }}</h3>
  <p class="subtitle">{{ "venta-rapida.product-step.subtitle" | translate }}</p>

  <div class="products-list">
    @for (product of products; track product.id) {
    <app-venta-rapida-product-card
      [product]="product"
      (selected)="onSelect($event)"
    />
    }
  </div>
</div>
